import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function Specifications() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
    <iframe
      src={t('Specifications_PDF')}
      title="PDF Document"
    />
  </div>
  );
}

export default Specifications;
